<template>
  <div class="integralUser seller-style">
    <h2 class="f18 lin-25 fb normal gray_2">拼单管理</h2>
    <div class="box30"></div>
    <div>
      <div class="flex items-center justify-between">
        <div class="flex flex1 items-center">
          <el-input class="w210 mar20_r" placeholder="请输入活动编号" v-model.trim="searchForm.id"></el-input>
          <el-input class="w210 mar20_r" placeholder="请输入活动名称" v-model.trim="searchForm.name"></el-input>
          <el-select class="w210 mar20_r" v-model="searchForm.status" placeholder="请选择状态">
            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <el-button type="primary" @click="searchList">查询</el-button>
          <el-button @click="restList">重置</el-button>
        </div>
        <div>
          <el-button type="primary" @click="toDetail('')">添加拼单</el-button>
        </div>
      </div>
      <div class="box30"></div>
      <el-table border :data="list" row-class-name="pointer">
        <el-table-column prop="id" label="活动编号" min-width="10%" />
        <el-table-column prop="name" label="活动名称" min-width="15%" />
        <el-table-column prop="priceType" label="活动类型" min-width="12%">
          <template slot-scope="scope">
            <!-- 秒杀拼单、阶梯拼单、集采拼单 -->
            <span v-if="scope.row.priceType === 1">阶梯拼单</span>
            <span v-else-if="scope.row.priceType === 2">秒杀拼单</span>
            <span v-else>集采拼单</span>
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="开始时间" min-width="15%" />
        <el-table-column prop="endTime" label="结束时间" min-width="15%" />
        <el-table-column prop="status" label="状态" min-width="10%">
          <template slot-scope="scope">
            <span class="blue" v-if="scope.row.status === 0">未开始</span>
            <span class="red" v-else-if="scope.row.status === 1">进行中</span>
            <span v-else>已结束</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="290">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 2" @click="toDetail(scope.row.id, 'end')">详情</el-button>
            <el-button v-else @click="toDetail(scope.row.id)">编辑</el-button>
            <el-button :loading="scope.row.shareLoading" @click="toShare(scope.row.id, scope.row.name, scope.$index)">{{
              scope.row.shareLoading ? "加载中" : "分享"
            }}</el-button>
            <el-button v-if="scope.row.status === 0" type="primary" @click="delItem(scope.row.id)">删除</el-button>
            <el-button v-else @click="toOrderList(scope.row.id)">订单汇总</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex items-center mar40-t">
        <div class="gray9 flex-auto">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
        <el-pagination
          layout="prev, pager, next, sizes, jumper"
          background
          hide-on-single-page
          :page-size.sync="pageSize"
          :page-count="totalPage"
          :current-page.sync="pageNum"
          :page-sizes="[10, 50, 100]"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="分享" :visible.sync="shareVisible" :close-on-click-modal="false" width="500px" center>
      <div class="text-center seller-style">
        <div class="f18 gray6 fb mar15-b">{{ shareInfo.name }}</div>
        <div class="f12">保存二维码或链接直接分享好友参加活动</div>
        <div>
          <img class="mar10-t mar15-b w160" :src="shareInfo.qrcodeImgUrl" />
        </div>
        <el-button class="share-btn" type="primary" @click="shareSave('img')">下载二维码</el-button>
        <div class="mar20-t">
          <span class="share-url">{{ shareInfo.shareUrl }}</span>
          <span class="mar20-l blue pointer" @click="shareSave('url')">复制</span>
          <!-- <span class="mar20-l blue">打开</span> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      env: process.env,
      searchForm: {
        id: "",
        name: "",
        status: "",
      },
      statusList: [
        {
          id: 0,
          name: "未开始",
        },
        {
          id: 1,
          name: "进行中",
        },
        {
          id: 2,
          name: "已结束",
        },
      ],
      list: [],

      pageSize: 10,
      pageNum: 1,
      totalPage: 1,
      pageTotal: 1,

      shareVisible: false,
      shareLoading: false,
      shareInfo: {},

      shippingType: 1,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.getList();
    this.getShopSetting();
  },
  methods: {
    getShopSetting() {
      this.$store.dispatch("shop/shop/queryShopDtlByBoId").then((res) => {
        // shippingType：店铺支持的配送类型:1-卖家配送,2-买家自提,3:-都支持
        if (res.data) {
          const { shopDtlEntity } = res.data;
          this.shippingType = shopDtlEntity.shippingType;
        }
      });
    },
    getList() {
      const { pageSize, pageNum, searchForm } = this;
      this.$store
        .dispatch("groupBuying/getCombinationOrderList", {
          ...searchForm,
          size: pageSize,
          current: pageNum,
        })
        .then((data) => {
          const { results, total, count } = data;
          console.log(data);
          this.list = results.map((item) => {
            return {
              ...item,
              shareLoading: false,
            };
          });
          this.totalPage = total;
          this.pageTotal = count;
        });
    },

    // 搜索
    searchList() {
      this.pageNum = 1;
      this.getList();
    },
    restList() {
      this.searchForm = {
        id: "",
        name: "",
        status: "",
      };
      this.pageNum = 1;
      this.pageSize = 10;
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },

    delItem(id) {
      this.$confirm("你确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.$store
          .dispatch("groupBuying/delCombinationOrder", {
            id,
          })
          .then((res) => {
            console.log(res);
            if (res.code === "0") {
              this.$message.success("删除成功！");
              this.getList();
            } else {
              this.$message.warning(res.msg);
            }
          });
      });
    },
    toDetail(id, type) {
      if (!id && this.shippingType === 2) {
        this.$confirm("该活动仅支持卖家配送方式，请您设置开启该配送方式", "提示", {
          confirmButtonText: "去开启",
          showCancelButton: false,
        }).then(() => {
          window.parent.postMessage({ fn: "open", data: { url: `${this.env.VUE_APP_APP}mj/toShopFunction?appid=1`, title: "系统设置", target: 0 } }, "*");
        });
        return;
      }
      const url = id ? (type === "end" ? `/mj/groupBuying/detail?id=${id}&isEnd=1` : `/mj/groupBuying/detail?id=${id}`) : "/mj/groupBuying/detail";
      this.$store.commit("app/setIsReload", true);
      this.$router.push(url);
    },
    toOrderList(id) {
      this.$router.push(`/mj/groupBuying/order?id=${id}`);
    },
    toShare(id, name, index) {
      this.list[index].shareLoading = true;
      // this.shareLoading = true;
      const shareUrl = `${this.env.VUE_APP_APP}vm/groupBuying?id=${id}`;
      this.$store
        .dispatch("groupBuying/getQrcodeToCombinationOrder", {
          shareUrl,
          imageSize: "300",
        })
        .then((data) => {
          this.list[index].shareLoading = false;
          if (data.qrcodeImgUrl) {
            this.shareVisible = true;
            this.shareInfo = {
              ...data,
              name,
            };
          } else {
            this.$message.warning("分享失败请稍候重试");
          }

          console.log(data);
        });
    },
    shareSave(type) {
      //  shareUrl：短连接 qrcodeImgUrl：二维码
      const { shareUrl, qrcodeImgUrl } = this.shareInfo;
      if (type === "url") {
        var cInput = document.createElement("input");
        cInput.value = shareUrl;
        document.body.appendChild(cInput);
        cInput.select();
        document.execCommand("copy");
        document.body.removeChild(cInput);
        this.$message.success("复制地址成功！");
      } else {
        this.downloadIamge(qrcodeImgUrl, "二维码");
        this.$message.success("保存二维码成功！");
      }
    },
    downloadIamge(imgsrc, name) {
      // 下载图片地址和图片名
      const image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        const url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
        const a = document.createElement("a"); // 生成一个a元素
        const event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
  },
  // 监听器
  filters: {},
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>
